import React from "react";

// Import your client logos
import NTFLogo from "../../../assets/clients/ntf.png";
import BharathForgeLogo from "../../../assets/clients/bharath-forge.png";
import LohiyaLogo from "../../../assets/clients/lohiya.png";
import DesigncoLogo from "../../../assets/clients/designco.png";
import MSPLogo from "../../../assets/clients/msp.png";
import FSMLogo from "../../../assets/clients/fsm.png";
import FluvinaLogo from "../../../assets/clients/fluvina.png";
import OrangewoodLogo from "../../../assets/clients/orangewood.png";
import IITDelhiLogo from "../../../assets/clients/iit-delhi.png";
import IITBhilaiLogo from "../../../assets/clients/IIT_Bhilai.png";

const ClientPortfolio = () => {
  const clients = [
    { logo: NTFLogo, name: "NTF Group Holdings", sector: "Automotive Sector" },
    { logo: BharathForgeLogo, name: "Bharat Forge", sector: "Automotive Sector" },
    { logo: LohiyaLogo, name: "Lohiya Group", sector: "Agri-Processing" },
    { logo: DesigncoLogo, name: "Designco", sector: "Glass Manufacturer" },
    { logo: MSPLogo, name: "MSP Steel", sector: "Steel Sector" },
    { logo: FSMLogo, name: "FSM", sector: "Smart Manufacturing CoE" },
    { logo: FluvinaLogo, name: "Fluvina Technologies", sector: "Health-Tech OEM" },
    { logo: OrangewoodLogo, name: "Orangewood", sector: "Robot OEM" },
    { logo: IITDelhiLogo, name: "IIT Delhi", sector: "IIT Delhi" },
    { logo: IITBhilaiLogo, name: "IIT Bhilai", sector: "IIT Bhilai" },
  ];

  return (
    <div className="w-full bg-white dark:bg-gray-900 py-10 xs:py-10 sm:py-12 md:py-16 px-4 xs:px-4 sm:px-6 mt-10 xs:mt-10 sm:mt-12 md:mb-20">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 xs:mb-10 sm:mb-12">
          <h2 className="text-3xl xs:text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-normal text-gray-900 dark:text-white mb-3 xs:mb-3 sm:mb-4  tracking-wide">
            Our Clients
          </h2>
          <div className="flex justify-center">
            <div className="w-20 xs:w-24 sm:w-28 h-1 bg-gradient-to-r from-amber-400 to-amber-600 rounded-full"></div>
          </div>
        </div>

        {/* Desktop/Tablet Version - Infinite Scroll with Labels */}
        <div className="hidden sm:block w-full bg-gray-100 dark:bg-gray-800 py-8 xs:py-10 sm:py-12 overflow-hidden rounded-xl">
          <div className="flex w-max animate-infinite-scroll hover:pause-animation">
            {/* Render logos 3 times for seamless loop */}
            {[...Array(3)].map((_, setIndex) => (
              <div key={setIndex} className="flex items-center">
                {clients.map((client, index) => (
                  <div
                    key={`${setIndex}-${index}`}
                    className="flex flex-col items-center mx-8 xs:mx-10 sm:mx-12 md:mx-14"
                  >
                    {/* Logo */}
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="h-16 xs:h-18 sm:h-20 md:h-24 w-auto object-contain mb-2 xs:mb-3"
                    />
                    {/* Sector Label */}
                    <p className="text-xs xs:text-sm sm:text-sm md:text-base font-medium text-gray-700 dark:text-gray-300 text-center whitespace-nowrap">
                      {client.sector}
                    </p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Version - Grid Layout */}
        <div className="sm:hidden w-full">
          <div className="grid grid-cols-2 gap-6 xs:gap-8">
            {clients.map((client, index) => (
              <div 
                key={index} 
                className="flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-800 p-4 xs:p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-14 xs:h-16 w-auto object-contain mb-2 xs:mb-3"
                />
                <p className="text-xs xs:text-sm font-medium text-gray-700 dark:text-gray-300 text-center leading-tight">
                  {client.sector}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientPortfolio;
